import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import {
  ConditionsReactivateVideoTutorielDto,
  VideoTutorielDto,
} from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateVideo from './ConditionReactivateVideo/ConditionReactivateVideo';
import ModalDetails from './Modals/ModalDetails';
import ModalModification from './Modals/ModalModification';
import { useChangeValidityVideoTutoriel } from './utils/useChangeValidityVideoTutoriel';

interface CellDetailsAndActionsProps {
  video: VideoTutorielDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  video,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalModification = useModal();
  const modalDeprecate = useModal();

  const {
    submitReactivateVideo,
    submitDeprecateVideo,
    conditionsReactivateVideo,
  } = useChangeValidityVideoTutoriel();

  const conditionUnlock = (
    conditions?: ConditionsReactivateVideoTutorielDto,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Modifier',
      onClick: modalModification.open,
    },
    {
      key: '2',
      label: video.valid ? 'Désactiver la vidéo' : 'Activer la vidéo',
      onClick: modalDeprecate.open,
    },
  ];

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        video={video}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <AntdDropdown menu={{ items }} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      <ModalModification
        refreshDashboard={refreshDashboard}
        video={video}
        visible={modalModification.visible}
        close={modalModification.close}
      />
      {video.valid ? (
        <ModalDesactivation
          idCorrelation={video.idCorrelation}
          titleModal="Désactiver la vidéo"
          submitDeprecate={submitDeprecateVideo}
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          usesRequest={undefined}
          componentUses={undefined}
        />
      ) : (
        <ModalReactivation
          idCorrelation={video.idCorrelation}
          titleModal="Réactiver la vidéo"
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          conditionRequest={conditionsReactivateVideo}
          componentConditions={ConditionReactivateVideo}
          conditionUnlock={conditionUnlock}
          reactivateRequest={submitReactivateVideo}
        />
      )}
    </>
  );
}

export default CellDetailsAndActions;
